import * as React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

const LocationSparkleIcon = ({ width = 24, height = 24 }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0.999634C16.9705 0.999634 20.9998 5.02922 21 9.99963C21 15.9996 13 22.9996 12 22.9996C11 22.9996 3 15.9996 3 9.99963C3.00018 5.02922 7.02955 0.999634 12 0.999634ZM15.2861 13.5719L13.7139 14.2858L15.2861 14.9996L16 16.5719L16.7139 14.9996L18.2861 14.2858L16.7139 13.5719L16 11.9996L15.2861 13.5719ZM8.85742 8.85706L5.71387 10.2858L8.85742 11.7145L10.2861 14.8571L11.7139 11.7145L14.8574 10.2858L11.7139 8.85706L10.2861 5.71448L8.85742 8.85706ZM15.2861 5.5719L13.7139 6.28577L15.2861 6.99963L16 8.5719L16.7139 6.99963L18.2861 6.28577L16.7139 5.5719L16 3.99963L15.2861 5.5719Z"
      fill="#1DA83B"
    />
  </SvgIcon>
);

LocationSparkleIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default LocationSparkleIcon;
